import React from 'react';
import MenuCarouselList from '@/components/menus/MenuCarouselList';
import useMenuList from '@/hooks/useMenuList';
import useMenuTaxonomyTitles from '@/hooks/useMenuTaxonomyTitles';

type ComponentProps = {
  type: string;
};

const MenuCookingListContainer: React.FC<ComponentProps> = ({ type }) => {
  const menuList = useMenuList();
  const menuTaxonomyTitles = useMenuTaxonomyTitles();
  return (
    <>
      {menuTaxonomyTitles.map((title) => {
        const menuListSingle =
          menuList
            .filter((item) => item.fields.type === type)
            .filter((item) => item.fields.cat === title) || [];
        return (
          <MenuCarouselList title={`「${title}」献立`} menuList={menuListSingle} key={title} />
        );
      })}
    </>
  );
};

export default MenuCookingListContainer;
